var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"plugin-referral-how-it-works"},[_c('div',{staticClass:"plugin-referral-how-it-works__items"},[_vm._t("default")],2),_c('div',{staticClass:"plugin-referral-how-it-works__button"},[_c('ui-button',{attrs:{"href":_vm.buttonLink,"text":"Пригласить клиента"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }